import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Loader2 } from 'lucide-react';

const AdminControls = () => { 
  const [syncing, setSyncing] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const functions = getFunctions();

  const handleAdminSync = async () => {
    try {
      setSyncing(true);
      setError(null);
      const adminSync = httpsCallable(functions, 'adminSyncAllSubscriptions');
      const result = await adminSync();
      console.log('Admin sync results:', result.data);
      setResults(result.data);
    } catch (error) {
      console.error('Admin sync error:', error);
      setError(error.message);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="space-y-4">
      {/* Sync All Button */}
      <button
        onClick={handleAdminSync}
        disabled={syncing}
        className={`w-full bg-emerald-500/20 hover:bg-emerald-500/30 text-emerald-200 
          font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2
          ${syncing ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        {syncing ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            Syncing All Subscriptions...
          </>
        ) : (
          'Sync All Subscriptions'
        )}
      </button>

      {/* Error Display */}
      {error && (
        <div className="bg-red-500/20 text-red-200 p-4 rounded-lg">
          {error}
        </div>
      )}

      {/* Results Display */}
      {results && (
        <div className="bg-slate-800/50 rounded-lg overflow-hidden">
          <div className="p-4 bg-slate-800">
            <h3 className="text-white font-medium flex items-center justify-between">
              <span>Sync Results</span>
              <span className="text-sm text-emerald-400">
                {new Date(results.syncedAt).toLocaleString()}
              </span>
            </h3>
          </div>
          <div className="p-4 max-h-96 overflow-auto">
            <table className="w-full text-sm text-left">
              <thead className="text-xs text-slate-400">
                <tr>
                  <th className="p-2">User ID</th>
                  <th className="p-2">Subscription ID</th>
                  <th className="p-2">Status</th>
                  <th className="p-2">Result</th>
                </tr>
              </thead>
              <tbody className="text-slate-300">
                {results.results.map((result, index) => (
                  <tr key={index} className="border-t border-slate-700/50">
                    <td className="p-2">{result.userId}</td>
                    <td className="p-2">{result.subscriptionId}</td>
                    <td className="p-2">
                      <span className={
                        result.status === 'success' 
                          ? 'text-emerald-400' 
                          : 'text-red-400'
                      }>
                        {result.status}
                      </span>
                    </td>
                    <td className="p-2">
                      {result.status === 'success' 
                        ? result.stripeStatus 
                        : result.error}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminControls;